import { Stack, Text } from '@mantine/core'
import React, { useEffect, useState } from 'react'

import { metaverseStandardDateAndTime } from '@/utils/utils'

const MSTClock: React.FC = () => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      const newTime = new Date()
      newTime.setSeconds(newTime.getSeconds() + 1)
      setCurrentTime(newTime)
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <Stack style={{ alignItems: 'flex-end', fontVariantNumeric: 'tabular-nums' }}>
      <Text>{metaverseStandardDateAndTime(currentTime)}</Text>
    </Stack>
  )
}

export default MSTClock
